import { createSelector } from 'reselect';

const selectMeasureDimensions = (state: any) => state.measureDimensions;


export const selectMeasureDimensionsCurrentItem = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.current);

export const selectMeasureDimensionsListItems = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.list);

export const selectMeasureDimensionsItemById = (itemId: any) =>
    createSelector(selectMeasureDimensionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectMeasureDimensionsQueryItems = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.query);

export const selectMeasureDimensionsCreatedItem = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.create);

export const selectMeasureDimensionsUpdatedItem = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.update);

export const selectMeasureDimensionsReadItem = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.read);

export const selectMeasureDimensionsDeletedItem = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.delete);

export const selectMeasureDimensionsSearchedItems = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.search);

export const selectMeasureDimensionsItemsCount = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.count);

export const selectMeasureDimensionsItemsFilter = createSelector([selectMeasureDimensions], (measureDimensions) => measureDimensions.filter);